import { css } from '@emotion/react';
import { Colors } from '../common/Colors';

//<style>*{scrollbar-width:thin}::-webkit-scrollbar{width:8px}</style>// должно быть добавлено в head страницы, чтобы подгружалось в самом начале

export const helperDesktopCustomScroll = css`
  scrollbar-width: thin;

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background: transparent;
    background-clip: padding-box;
  }

  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
  }

  ::-webkit-scrollbar-thumb {
    box-sizing: border-box;
    background: ${Colors.scroll.normal};
    background-clip: padding-box;
    border-radius: 5rem;

    &:hover {
      background: ${Colors.scroll.up};
    }

    &:active {
      background: ${Colors.scroll.down};
    }
  }

  ::-webkit-scrollbar-track {
    background: transparent;
    border: 0 none transparent;

    &:hover {
      background: transparent;
    }

    &:active {
      background: transparent;
    }
  }

  ::-webkit-scrollbar-corner {
    background: transparent;
  }
`;
